/** 阅读模块 localStorage 键名映射（配合 k-soup local.clear） */
import type { IStoreMap } from 'k-soup/utils/store';

export const READBOOK_STORAGE_PREFIX = 'k_readbook_v1';

export const readbookStoreMap = {
  APP_THEME: { name: 'k_app_theme_v1', clear: false },
  SETTINGS: { name: `${READBOOK_STORAGE_PREFIX}:settings`, clear: false },
  LAST_READ: { name: `${READBOOK_STORAGE_PREFIX}:last_read`, clear: false },
  UPLOADED_BOOKS: { name: `${READBOOK_STORAGE_PREFIX}:uploaded_books`, clear: false },
} as const satisfies IStoreMap;

export const readbookKeys = {
  progress: (bookId: string) => `${READBOOK_STORAGE_PREFIX}:progress:${bookId}`,
  marks: (bookId: string) => `${READBOOK_STORAGE_PREFIX}:marks:${bookId}`,
  notes: (bookId: string) => `${READBOOK_STORAGE_PREFIX}:notes:${bookId}`,
  notesPrefix: `${READBOOK_STORAGE_PREFIX}:notes:`,
};
